<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table [tableConfig]="tableConfig" [items]="cenovniciTable" [isTableLoading]="isLoading">
  </kodit-table>
</kodit-page>
